export default __webpack_public_path__ + "static/media/gallery_03.7cf94c29.jpg";